import { render } from "./Prices.vue?vue&type=template&id=b3f68b98&ts=true"
import script from "./Prices.vue?vue&type=script&lang=ts"
export * from "./Prices.vue?vue&type=script&lang=ts"

import "./Prices.vue?vue&type=style&index=0&id=b3f68b98&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__